const getNameOfUser = (user) => `${user.last_name}, ${user.first_name}`;

export default getNameOfUser;
